// Anzeigenamen der Rollen (Einstellungen: Profil und Nutzer).
export const ROLLEN: Record<string, string> = { admin: "Admin", superuser: "Super User", user: "User", restricted: "Eingeschränkt" };
